import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as Types from 'types'
import { Card, ProfileCompletionBar } from 'components'
import {
  buildBarModel,
  buildInterestCompletionOptions,
} from '../summary/profile-completion-sections'

const propTypes = {
  school: Types.school.isRequired,
  profileCompletionOptions: PropTypes.object,
}

const defaultProps = {
  profileCompletionOptions: {},
}

function ProfileCompletionCard({ school, profileCompletionOptions }) {
  const { sections, completedSections, percent } = buildBarModel(
    school,
    profileCompletionOptions
  )

  return (
    <Card>
      <ProfileCompletionBar
        variant="card"
        percent={percent}
        completedSections={completedSections}
        sections={sections}
      />
    </Card>
  )
}

ProfileCompletionCard.propTypes = propTypes
ProfileCompletionCard.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    profileCompletionOptions: buildInterestCompletionOptions(state),
  }
}

export default compose(connect(mapStateToProps))(ProfileCompletionCard)
